export enum DocumentReadModes {
  
  NO_PHOTO = 0,
  DOCUMENT_READ_AND_SELFIE = 1,
  DOCUMENT_READ_ONLY = 2
//   "0" - nincs fényképezés
// "1" - Okmányolvasás + szelfi
// "2" - Csak okmányolvasás
}